import { render, staticRenderFns } from "./RefillPriceTable.vue?vue&type=template&id=3f5d4730&scoped=true"
import script from "./RefillPriceTable.vue?vue&type=script&lang=js"
export * from "./RefillPriceTable.vue?vue&type=script&lang=js"
import style0 from "./RefillPriceTable.vue?vue&type=style&index=0&id=3f5d4730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d4730",
  null
  
)

export default component.exports